var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.243,
    height: 13.501,
    viewBox: "0 0 20.243 13.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M7.334.259a.919.919,0,0,1,.007,1.294L3.073,5.834H19.336a.914.914,0,0,1,0,1.828H3.073l4.275,4.282a.925.925,0,0,1-.007,1.294.91.91,0,0,1-1.287-.007L.26,7.4h0a1.026,1.026,0,0,1-.19-.288A.872.872,0,0,1,0,6.755a.916.916,0,0,1,.26-.64L6.054.28A.9.9,0,0,1,7.334.259Z",
    transform: "translate(20.243 13.501) rotate(180)",
    fill: "#3497d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a116b5aa4069351ecc1a6a773bc9a272.svg";
export { ForwardRef as ReactComponent };